import { useLocation } from '@remix-run/react'
import { useMemo } from 'react'

import { makeShopOwnPath } from '~/helpers/routes'
import { useShop } from '~/hooks/data/use-shop'

type Page =
  | 'home'
  | 'product'
  | 'collection'
  | 'settings'
  | 'orders'
  | 'unknown'
  | 'account'
  | 'legal'

const removeTrailingSlash = (path: string) => {
  return path.endsWith('/') ? path.slice(0, -1) : path
}

export const useCurrentPage = (): Page => {
  const shop = useShop()
  const { pathname } = useLocation()

  return useMemo(() => {
    if (pathname.startsWith(makeShopOwnPath(shop, '/settings'))) {
      return 'settings'
    }

    if (pathname.startsWith(makeShopOwnPath(shop, '/account'))) {
      return 'account'
    }

    if (pathname.startsWith(makeShopOwnPath(shop, '/orders'))) {
      return 'orders'
    }

    if (pathname.startsWith(makeShopOwnPath(shop, '/products/'))) {
      return 'product'
    }

    if (pathname.startsWith(makeShopOwnPath(shop, '/collections/'))) {
      return 'collection'
    }

    if (pathname.startsWith(makeShopOwnPath(shop, '/legal'))) {
      return 'legal'
    }

    if (
      removeTrailingSlash(pathname) === makeShopOwnPath(shop, '') ||
      pathname.startsWith(makeShopOwnPath(shop, '/collections'))
    ) {
      return 'home'
    }

    return 'unknown'
  }, [shop, pathname])
}
